import percentDiscountIcon from "./../images/percent-discount.svg";
import earlyBirdIcon from "./../images/alarm-clock.svg";
import { format } from "date-fns";
import i18n from "../../i18n";
import { getImage } from "../../utils/pathHelper";

export const renderEarlyBirdAmount = (saleDateTo: Date) => {
	const earlyBirdText = i18n.t("snow_items.show.early_bird_price_until_html", {
		date: format(saleDateTo, "MM/dd"),
	});
	return (
		<div className="snow-item-highlight-badge snow-item-highlight-badge--early-bird">
			<img src={getImage(earlyBirdIcon)} alt="Early Bird" />
			<span dangerouslySetInnerHTML={{ __html: earlyBirdText }} />
		</div>
	);
};

export const renderAnyDiscountAmount = () => {
	const anyDiscountText = i18n.t(
		"snow_items.show.cheaper_online_than_on_site_html",
	);
	return (
		<div className="snow-item-highlight-badge snow-item-highlight-badge--discount">
			<img src={getImage(percentDiscountIcon)} alt="Percent Discount" />
			<span dangerouslySetInnerHTML={{ __html: anyDiscountText }} />
		</div>
	);
};
